module.exports = __webpack_public_path__ + "static/venice20895-445c18c9297fde0bd77b2375c4882c34.webp";